import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, IconButton, Typography } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {useSelector} from "react-redux"
import {
  ArrowBack,
  ArrowCircleDown,
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { decode } from "../../../Component/JWT/Formatt";
import ComponentItemModal from "./ComponentItemModal";


const ComponentItem = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [cloneOption,setCloneOption]=useState(false)
  const code = searchParams.get("code")
  const name = searchParams.get("name")
  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const id=decode(searchParams.get("id"))
    const link = masterAPI["componentItem"].getComponentItemByComId;
   await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => {
        console.log(res.data, "component Item result");
        setData(res.data.result);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "component Item");
        setIsLoading(false);
        setData([])
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleDelete = async(id) => {
    const deleteLink = masterAPI["componetItem"].delete;
   await axiosPrivate
      .delete(`${deleteLink}/${id}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "delete ComponentItem");
      });
  };

  const columns = [
    
    {
      Header: "Item Code",
      accessor: "itemCode",
      // disableFilters: true,
    },
    {
      Header: "Item Name",
      accessor: "itemName",
    },
    {
      Header: "Sub Unit Category ",
      accessor: "subUnitCategory",
      // Cell: ({ row }) => {
      //   const { attributeTextValue, attributeNumericValue, attributeDateValue } = row.original;
      //   const values = [];
  
      //   if (attributeTextValue !== " " && attributeTextValue !== "") values.push(attributeTextValue);
      //   if (attributeNumericValue !== 0) values.push(attributeNumericValue);
      //   if (attributeDateValue) values.push(attributeDateValue);
  
      //   return values.join(', ') || null;  // Join values with a comma or show 'N/A' if all are empty
      // },
    },
    // {
    //   Header: "Attribute Text",
    //   accessor: "attributeTextValue",
    // },
    // {
    //   Header: "Attribute Date",
    //   accessor: "attributeDateValue",
    // },
   

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
            <IconButton disabled={!actionsAllow.edit}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const handleCloneButton=()=>{
   setCloneOption(true)
  }

  const handleCloseClone=()=>{
    setCloneOption(false)
  }

  return (
    <>
      <Box  sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "100%",
             // mb: "1rem",
              gap: "1rem",
            }}>
        <Link to="/masters/component"><IconButton><ArrowBack/></IconButton></Link>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            // mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI['componentItem'].title}
         
        </Typography>
         <Typography
                      sx={{
                        color: color.masterPageTitleColor,
                        fontSize: '16px',
                        fontWeight: 'normal',
                      }}
                    >
                      - {code} - {name}
                    </Typography>
      </Box>
     
        <TableContainer
          columns={columns}
          data={data}
          buttonNew={handleButtonNew}
          loading={isLoading}
          buttonDisable={!actionsAllow.edit}
          // clone={true}
          // handleCloneButton={handleCloneButton}
        />
   

      <Dialog
        open={create}
        onClose={handleCreateClose}
        PaperProps={{
          sx: {
            maxWidth: '70vw',
            width:"65vw"
          },
        }}
        children={
          <ComponentItemModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
      {/* <Dialog
        open={cloneOption}
        onClose={handleCloseClone}
        PaperProps={{
          sx: {
            maxWidth: '70vw',
            width:"65vw"
          },
        }}
        children={
          <CloneTechSpec
            handleCloseClick={handleCloseClone}
            
          />
        }
      /> */}
    </>
  );
};

export default ComponentItem;
